import View from './view';
export const SocialSupportMeasuresLink = View;
